import React, { Component } from 'react'
import { View } from 'react-native'
import { Picker } from '@react-native-picker/picker'

import { defaults } from './index'

export default class SelectSub extends Component {
  state = {
    color: defaults.COLOR,
    backgroundColor: defaults.BACKGROUND_COLOR,
  }

  componentDidMount() {
    this.handleColor()
    this.handleBackgroundColor()
  }

  componentDidUpdate(prevProps) {
    const { object, value } = this.props

    if (prevProps.value !== value) {
      this.handleColor()
    }

    if (prevProps.object.attributes !== object.attributes) {
      this.handleColor()
      this.handleBackgroundColor()
    }
  }

  handleChange = val => {
    const { onChange } = this.props

    if (val === '_placeholder') {
      val = null
    }

    onChange(val)
  }

  handleColor = () => {
    const { object, value } = this.props
    const { attributes } = object
    const { color } = attributes

    if (value && value !== '_placeholder') {
      this.setState({ color })
    } else {
      this.handlePlaceholderColor()
    }
  }

  handlePlaceholderColor = () => {
    const { object } = this.props
    const { attributes } = object
    const { placeholderColor } = attributes

    if (placeholderColor) {
      this.setState({ color: placeholderColor })
    } else {
      this.setState({ color: defaults.COLOR })
    }
  }

  handleBackgroundColor = () => {
    const { object } = this.props
    const { attributes } = object

    const { backgroundColor } = attributes

    if (backgroundColor) {
      this.setState({ backgroundColor })
    } else {
      this.setState({ backgroundColor: defaults.BACKGROUND_COLOR })
    }
  }

  render() {
    const { object, style, options, value } = this.props
    const {
      attributes: { padding, height },
    } = object
    const { color, backgroundColor } = this.state

    const paddingLeft = Math.max(0, padding - 4)
    const paddingRight = Math.max(0, padding - 8)

    // first we divide the height by 2 to get the margins for each side then
    // we subtract default margin of the Android Picker (12 + 12 = 24)
    const marginTop = height / 2 - 24
    const marginBottom = height / 2 - 24

    const marginLeft = padding - 12
    const marginRight = padding - 12

    const currentOption = options.find(opt => opt.value === value)

    const finalValue = (currentOption && currentOption.value) || '_placeholder'

    return (
      <View
        style={[
          style,
          {
            paddingLeft,
            paddingRight,
            backgroundColor,
          },
        ]}
      >
        <Picker
          onValueChange={this.handleChange}
          selectedValue={finalValue}
          style={{
            color,
            marginLeft,
            marginRight,
            marginTop,
            marginBottom,
          }}
        >
          {options.map(opt => (
            <Picker.Item {...opt} key={opt.value} />
          ))}
        </Picker>
      </View>
    )
  }
}
